import { View }     from 'backbone';
import template     from 'common-views/play-form.ejs';
import restService  from 'RestService.js';
import constants    from 'Constants.js';

class PlayFormModal extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
       
        return this;
    }

    playForm() {

        const url = this.model.get('url') + '&t=' + restService.getToken();
        $('#playContent').prop('src', url);        
    }

    bindEvents() {
        this.playForm();
    }

    closeModal() {

        const profile = restService.getProfile();

        //PF-8390 If basic user and has a report assigned
        if(profile.Status === "1" && profile.HomeReport && profile.HomeReport !== ""){
            Backbone.history.loadUrl('login');
        }

        $('#playFormModal').remove();
    }

    clearLock() {
        const linkId = this.model.get('id').replace('&viewForm=true', '');
        if(linkId && linkId.length > constants.LENGTH_LINKID){
           restService.clearLock(linkId);
        }
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);


            let self = this;

            this.dialog = $('#playFormModal').dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: $(window).height(),
                width: $(window).width(),
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Close',
                        'class':'btn-select-field',
                        click: () => {
                            $('#playContent').remove();
                            this.dialog.dialog( "close" );
                            this.clearLock();
                            this.closeModal();
                            resolve( this.model.get('result') );
                        }
                    }
                ],
                close: () => {
                    this.dialog.dialog("destroy");
                    this.closeModal();
                },
                open: () =>{
                    self.bindEvents();
                }
            });


            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

            this.delegateEvents();
            return this;
        });
    }


}export default PlayFormModal;